import React from "react";

 export default function RateCard() {
    return(
        <>
        <p>Rate Card Page</p>
        </>
    );
 }
